
import { Apartment } from '@/interfaces/apartment.interface';
import router from '@/router';
import { ApartmentService } from '@/services/ApartmentService';
import { apiUrl, axiosAuthPost } from '@/services/utils';
import { defineComponent, PropType } from 'vue';
import Overlay from './Overlay.vue';

export default defineComponent({
    setup() {

    },
    props: {
        apartment: {
            type: Object as PropType<Apartment>
        }
    },
    components: {
        Overlay
    },
    data() {
        return {
            spin: false,
            hasClicked: false,
            formData: {
                name: this.apartment?.name,
                description: this.apartment?.description,
                type: this.apartment?.type,
                price: this.apartment?.price,
                ac: this.apartment?.ac,
                balcony: this.apartment?.balcony,
                beds: this.apartment?.beds
            },
        }
    },
    methods: {
        async updateApartment() {
            this.hasClicked = true;
            this.spin = true;
            let result = await new ApartmentService().updateApartment(this.formData, this.apartment)
            console.log(result);
            this.spin = false;
            // emits event to parent on successful apartment creation
            this.$emit('apartmentUpdated');
            this.$toast.add({ severity: 'success', summary: 'Success', detail: 'Apartment successfully updated', life: 3000 });
            this.hasClicked = false;
        },
    }
})
